import {
  Badge,
  Box,
  Card,
  Table,
  TableBody,
  TableBodyCell,
  TableBodyRow,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  Text,
  theme,
} from "@aksara-ui/react";
import { InputSearchbox } from "components/Form/InputSearchbox";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { getAllRedeemActivities } from "redux/actions";
import styled from "styled-components";
import {
  Pagination,
  PaginationDetail,
  PaginationFilter,
} from "components/Pagination";
import TableBodyRowsSkeleton from "components/TableBodyRowSkeleton";
import { toCapitilizeCase } from "utilities/helper/toCapitalizeCase";
import moment from "moment";

const HeaderWrapper = styled(Box)`
  justify-content: space-between;
  margin-bottom: 30px;
  gap: 20px;
`;

const RedeemActivityContent: React.FC = () => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 576 });

  const { isLoading } = useSelector((state: any) => state.globalReducer);
  const { redeemActivities } = useSelector(
    (state: any) => state.redeemActivityReducer
  );
  const { currentPage, totalPage, limitPage, lengthPage } = useSelector(
    (state: any) => state.redeemActivityReducer
  );

  const [searchValue, setSearchValue] = useState("");
  const [limit, setLimit] = useState(10);

  const handleSearchChange = (event: any) => {
    setSearchValue(event.target.value);
    dispatch(getAllRedeemActivities(1, event.target.value, limitPage) as any);
  };

  const handleClearSearchChange = () => {
    setSearchValue("");
    dispatch(getAllRedeemActivities(currentPage, "", limitPage) as any);
  };

  useEffect(() => {
    dispatch(getAllRedeemActivities() as any);
  }, [dispatch]);

  return (
    <Box height={"100%"} paddingY={20} paddingX={isMobile ? 30 : 50}>
      <HeaderWrapper
        display={"flex"}
        flexDirection={"column"}
        style={{ gap: 20 }}
      >
        <Box display={"flex"}>
          <Text scale={[500, 600]} fontWeight={700}>
            Redeem Activity
          </Text>
        </Box>

        <Box
          display={"flex"}
          flexDirection={isMobile ? "column" : "row"}
          justifyContent={"space-between"}
          style={{ gap: isMobile ? 10 : 20 }}
        >
          <InputSearchbox
            autoComplete="off"
            name="search"
            placeholder="Search..."
            size={32}
            onChange={handleSearchChange}
            onClearButton={handleClearSearchChange}
          />
        </Box>
      </HeaderWrapper>

      <Card maxHeight={"100%"} overflow={"auto"} elevation={2}>
        <Table>
          <TableHead
            position={"sticky"}
            top={0}
            backgroundColor={theme.colors.grey02}
          >
            <TableHeadRow>
              <TableHeadCell>User</TableHeadCell>
              <TableHeadCell>Reward</TableHeadCell>
              <TableHeadCell minWidth={150}>Type</TableHeadCell>
              <TableHeadCell>Product</TableHeadCell>
              <TableHeadCell minWidth={150}>Point Used</TableHeadCell>
              <TableHeadCell>Source</TableHeadCell>
              <TableHeadCell>Date/Time</TableHeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableBodyRowsSkeleton rowsNumber={10} columnsNumber={7} />
            ) : !redeemActivities.length ? (
              <TableBodyRow>
                <TableBodyCell colSpan={7} textAlign={"center"}>
                  No data available in table
                </TableBodyCell>
              </TableBodyRow>
            ) : (
              redeemActivities.map((redeem: any) => {
                return (
                  <TableBodyRow key={redeem.user_catalog_id}>
                    <TableBodyCell>{redeem.member_name}</TableBodyCell>
                    <TableBodyCell>{redeem.catalog_name}</TableBodyCell>
                    <TableBodyCell whiteSpace={"nowrap"}>
                      <Badge
                        size="md"
                        variant={redeem.point_type === "0" ? "warning" : "info"}
                      >
                        {redeem.point_type === "0"
                          ? "Exp Point"
                          : "Ancol Point"}
                      </Badge>
                    </TableBodyCell>
                    <TableBodyCell>{redeem.catalog_product}</TableBodyCell>
                    <TableBodyCell>
                      <Badge size="md" variant="critical">
                        {redeem.points_used.toLocaleString()}
                      </Badge>
                    </TableBodyCell>
                    <TableBodyCell>
                      {toCapitilizeCase(redeem.source)}
                    </TableBodyCell>
                    <TableBodyCell>
                      {moment(redeem.created_at).format(
                        "DD MMMM YYYY, HH:mm:ss"
                      )}
                    </TableBodyCell>
                  </TableBodyRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </Card>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        paddingY={10}
      >
        {!isMobile ? (
          <PaginationDetail
            page={currentPage}
            limit={limitPage}
            length={lengthPage}
          />
        ) : (
          ""
        )}
        <Pagination
          current={currentPage}
          total={totalPage}
          onSelect={(select: any) =>
            dispatch(
              getAllRedeemActivities(select, searchValue, limitPage) as any
            )
          }
        />
        <PaginationFilter
          selectedItem={limit}
          onChange={(selectedItem) => {
            if (selectedItem) {
              setLimit(selectedItem);
              dispatch(
                getAllRedeemActivities(1, searchValue, selectedItem) as any
              );
            }
          }}
          items={[10, 20, 30, 40, 50]}
        />
      </Box>
    </Box>
  );
};

export default RedeemActivityContent;
